/** 麦卡通过独立构建环境部署，复用现有后端。 */
export function isMaikaEnvironment(): boolean {
  return typeof ENV !== 'undefined' && ['testmktaxi', 'onlinemktaxi'].includes(ENV);
}

/** 显式界面预览仅在开发、测试环境开放。 */
export function isMaikaPreviewEnabled(): boolean {
  if (typeof window === 'undefined' || typeof ENV === 'undefined') return false;
  return ['dev', 'test', 'testtaxi', 'testmktaxi'].includes(ENV) &&
    window.location.pathname.replace(/\/$/, '') === '/pad' &&
    new URLSearchParams(window.location.search).get('maikaPreview') === '1';
}
